import { Component, OnInit, OnDestroy, Input } from '@angular/core';
//import { Helpers } from '../helpers/helpers';
// import { UserInfoService } from './../services/user-info.service';
// import { IUser } from './../models/user.model';
// import { Subscription } from 'rxjs';
// import { ZpDataService } from 'src/app/services/zp-data.service';
import { Router } from '@angular/router';
import { FinancialSummaryCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { Subscription } from 'rxjs';
import { FinancialSummaryModeService } from './../services/financial-summary-mode.service';
import { ThemeService } from '../theme/theme-service.service';


@Component({
    selector: 'app-financial-summaries-net-worth',
    templateUrl: './financial-summaries-net-worth.component.html',
    styleUrls: ['./financial-summaries-net-worth.component.scss'],
    standalone: false
})
export class FinancialSummariesNetWorthComponent implements OnInit {
  // myUser: IUser;
  // subscription: Subscription;
  // myCategoriesBalance: {}[];
  public chosentab;
  public subscription: Subscription;
  @Input() public assets: number;
  @Input() public debts: number;

  constructor(private router: Router,
    private financialSummaryCategoriesSetFilterService: FinancialSummaryCategoriesSetFilterService,
    private financialSummaryModeService: FinancialSummaryModeService, public themeService: ThemeService) {
  }

  setFilter(filter) {
    this.chosentab = filter;
    this.financialSummaryCategoriesSetFilterService.changeMessage(filter);
    this.financialSummaryModeService.changeMessage("true");
  }

  ngOnInit() {
    this.subscription = this.financialSummaryCategoriesSetFilterService.getMessage().subscribe(async filter => {
      this.chosentab = filter;
    });
  }

  ngOnDestroy() {
    //this.subscription.unsubscribe();
  }

}
